import footerLogo from "@/assets/footer_logo.svg";
import { LIVE_TOOLS } from "@/lib/tools";
import { Link } from "react-router-dom";

const PinterestFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
    </svg>
);

const TwitterFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
    </svg>
);

const LinkedinFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.339 18.337v-8.13H5.667v8.13H8.34zM7.003 9.06a1.548 1.548 0 1 0 0-3.097 1.548 1.548 0 0 0 0 3.097zm11.336 9.277v-4.45c0-2.32-.5-4.1-3.21-4.1-1.302 0-2.176.714-2.533 1.39h-.036v-1.176H9.97v8.336h2.67v-4.124c0-1.087.207-2.14 1.555-2.14 1.328 0 1.347 1.243 1.347 2.21v4.054h2.797z" />
    </svg>
);

const YoutubeFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
    </svg>
);

const InstagramFilled = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23a3.7 3.7 0 0 1-.9 1.38 3.7 3.7 0 0 1-1.38.9c-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.85 5.85 0 0 0-2.13 1.38A5.85 5.85 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.73 1.46 1.38 2.13.67.65 1.34 1.07 2.13 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.73 2.13-1.38a5.85 5.85 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.85 5.85 0 0 0-1.38-2.13A5.85 5.85 0 0 0 19.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16A4 4 0 1 1 12 8a4 4 0 0 1 0 8zm6.41-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" />
    </svg>
);

const socialIcons = [
    {
        Icon: InstagramFilled,
        label: "Instagram",
        href: "https://www.instagram.com/pixroai/",
    },
    { Icon: TwitterFilled, label: "X", href: "https://x.com/pixroai" },
    {
        Icon: PinterestFilled,
        label: "Pinterest",
        href: "https://in.pinterest.com/pixroai/",
    },
    {
        Icon: LinkedinFilled,
        label: "LinkedIn",
        href: "https://in.linkedin.com/company/pixroai",
    },
    {
        Icon: YoutubeFilled,
        label: "YouTube",
        href: "https://www.youtube.com/@PixroAI",
    },
];

const staticColumns = [
    {
        title: "Solutions",
        links: [
            { label: "Fashion", href: "/solutions/fashion" },
            { label: "Ecommerce", href: "/solutions/ecommerce" },
            { label: "Accessories", href: "/solutions/accessories" },
            { label: "Jewellery", href: "/solutions/jewellery" },
            { label: "Automobile", href: "/solutions/automobile" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About us", href: "/about" },
            { label: "AI Team", href: "/ai-team" },
            { label: "Pricing", href: "/pricing" },
            { label: "APIs", href: "/apis" },
            { label: "Blogs", href: "/blogs" },
        ],
    },
    {
        title: "Help & Legal",
        links: [
            { label: "Contact us", href: "/contact" },
            { label: "Terms & Conditions", href: "/terms-and-conditions" },
            { label: "Privacy Policy", href: "/privacy-policy" },
        ],
    },
];

const Footer = () => {
    return (
        <footer className="bg-[hsl(210,12%,7%)] pt-12 sm:pt-16 pb-10">
            <div className="px-6 sm:px-10 md:px-[10%] lg:px-[15%]">
                {/* Links grid */}
                <div className="grid gap-10 grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
                    {/* Follow us column with icons */}
                    <div className="col-span-2">
                        <h4 className="mb-6 text-base font-semibold text-foreground">
                            Follow us
                        </h4>
                        <div className="grid grid-cols-3 gap-4 max-w-[160px]">
                            {socialIcons.map(({ Icon, label, href }) => (
                                <a
                                    key={label}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={label}
                                    className="text-muted-foreground transition-colors hover:text-foreground"
                                >
                                    <Icon width={24} height={24} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Our tools — link directly to the app */}
                    <div>
                        <h4 className="mb-6 text-base font-semibold text-foreground">
                            Our tools
                        </h4>
                        <ul className="space-y-3">
                            {LIVE_TOOLS.map((tool) => (
                                <li key={tool.toolType}>
                                    <a
                                        href={tool.appHref}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                    >
                                        {tool.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Static columns */}
                    {staticColumns.map((col) => (
                        <div key={col.title}>
                            <h4 className="mb-6 text-base font-semibold text-foreground">
                                {col.title}
                            </h4>
                            <ul className="space-y-3">
                                {col.links.map((link) => (
                                    <li key={link.label}>
                                        <Link
                                            to={link.href}
                                            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                        >
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* Full-width logo */}
            <div className="mt-16 sm:mt-20 px-4">
                <img
                    src={footerLogo}
                    alt="PIXRO AI"
                    width={1417}
                    height={210}
                    className="w-full select-none"
                />
            </div>

            {/* Copyright */}
            <p className="mt-8 sm:mt-10 px-6 text-center text-xs sm:text-sm text-muted-foreground">
                Copyrights ©2026 All rights Reserved
            </p>
        </footer>
    );
};

export default Footer;
